import React from 'react';
import { func } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import BobConfirmButton from '../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const DeleteSiteModal = ({
    clearErrors,
    deleteSite,
    fetchSites,
    isLoading,
    onClose,
    site,
    toggleLoading
}) => {
        
    const handleDelete = async () => {
        const clientId = site.clientId;

        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteSite(site.siteId, clientId);
        }

        if (isDeleted) handleClose();
    };

    const handleClose = () => {
        const body = {};
        clearErrors();
        toggleLoading(false);
        fetchSites(body);
        onClose();
    };

    return (
        <React.Fragment>
            <ErrorOutlineIcon className={classes.warningIcon} />
            <div className={classes.text}>
                <p className={classes.desc}> Are you sure you want to delete the entity below?</p>
                <p className={classes.name}>Site</p>
                <p className={classes.entityName}>{site.siteName}</p>
            </div>
            <Button
                className={classes.Button}
                onClick={handleClose}
                variant="contained"
            >
                Cancel
            </Button>
            <BobConfirmButton
                className={classes.ButtonWithMargin}
                isLoading={isLoading}
                label={'Yes'}
                onClick={handleDelete}
            />
        </React.Fragment>
    );
};


DeleteSiteModal.propTypes = {
    onClose: func.isRequired
};

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSiteModal);
